<template>
  <!-- <div
    class="w-367px h-full bg-contain bg-no-repeat absolute component-container transition-all z-998 top-0 right-calc[-390%]"
  > -->
  <div class="h-full overflow-y-scroll">
    <!-- <cardTitle title="摄像头信息" class="mb-10px" /> -->
    <el-collapse accordion v-model="activeName" class="border-0">
      <el-collapse-item
        class="mt-16px border-0"
        v-for="(item, index) in currentRelationData"
        :key="item.id"
        :name="index"
      >
        <template slot="title">
          <span class="truncate text-left text-14px !leading-30px">{{ item.name }}</span>
        </template>
        <div class="w-full flex justify-start items-center leading-20px h-20px mt-12px">
          <img src="../../../assets/images/titleIcon.png" alt />
          <div class="text-16px text-white ml-4px">基础信息</div>
        </div>
        <div class="w-full flex">
          <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
            >任务编号：</span
          >
          <span class="truncate text-white text-14px !leading-30px">{{ item.code }}</span>
        </div>
        <div class="w-full flex">
          <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
            >任务名称：</span
          >
          <span class="truncate text-white text-14px !leading-30px">{{ item.name }}</span>
        </div>
        <div class="w-full flex">
          <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
            >计划开始时间：</span
          >
          <span class="truncate text-white text-14px !leading-30px">{{
            new Date(item.planStartDate).toISOString().split('T')[0]
          }}</span>
        </div>
        <div class="w-full flex">
          <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
            >计划结束时间：</span
          >
          <span class="truncate w-200px text-white text-14px !leading-30px">{{
            new Date(item.planFinishDate).toISOString().split('T')[0]
          }}</span>
        </div>
        <div class="w-full flex">
          <span
            class="lefttruncate text-left inline-block text-14px !leading-30px text-white opacity-60"
            >是否里程碑：</span
          >
          <span class="truncate text-white text-14px !leading-30px">{{
            item.isMilestone === 0 ? '是' : item.isMilestone === 1 ? '否' : ''
          }}</span>
        </div>
        <div class="w-full flex">
          <span
            class="lefttruncate text-left inline-block text-14px !leading-30px text-white opacity-60"
            >实际开始时间：</span
          >
          <span class="truncate text-white text-14px !leading-30px">{{
            new Date(item.startDate).toISOString().split('T')[0]
          }}</span>
        </div>
        <div class="w-full flex">
          <span
            class="lefttruncate text-left inline-block text-14px !leading-30px text-white opacity-60"
            >实际结束时间：</span
          >
          <span class="truncate text-white text-14px !leading-30px">{{
            new Date(item.finishDate).toISOString().split('T')[0]
          }}</span>
        </div>
        <div class="w-full flex">
          <span
            class="lefttruncate text-left inline-block text-14px !leading-30px text-white opacity-60"
            >任务进度：</span
          >
          <span class="truncate text-white text-14px !leading-30px">{{ item.excuteState }}</span>
        </div>
        <div class="w-full flex justify-start items-center leading-30px h-30px mt-16px">
          <img src="../../../assets/images/titleIcon.png" alt />
          <div class="text-16px text-white ml-4px">电子工作包</div>
        </div>
        <template v-if="item.nsdPackage">
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >工作包分配人员姓名：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.workManagerName
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="truncate text-left text-14px !leading-30px text-white opacity-60"
              >任务分配人员工号：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.workManagerAccount
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >工作包创建人员姓名：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.createUserName
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >任务描述：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.remark
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >任务创建时间：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.createTime
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >任务下发时间：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.distributeTime
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >任务状态：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.status === 1 ? '正常' : res.Data.status === 2 ? '停用' : ''
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >任务开始时间：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.actualStartTime
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >任务结束时间：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.actualEndTime
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >任务完成进度：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.execStatus
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >最后一次修改时间：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.lastModifyTime
            }}</span>
          </div>
          <div class="w-full flex">
            <span class="lefttruncate text-left text-14px !leading-30px text-white opacity-60"
              >最后一次修改人姓名：</span
            >
            <span class="truncate text-white text-14px !leading-30px">{{
              item.nsdPackage.lastModifyUserName
            }}</span>
          </div>
          <div class="pt-6px felx" v-for="ele in item.nsdPackage.extFileInfoList" :key="ele.id">
            <!-- <i class="el-icon-document"></i> -->
            <!-- <el-link type="primary" class="truncate w-full" :href="`${nsdBaseIp}${ele.filePath}`"
            >{{ ele.fileOriginName }} <i class="el-icon-view ml-20px"></i
          ></el-link> -->
            <!-- <div class="w-full flex justify-start items-center leading-30px h-30px">
              <img src="../../../assets/images/titleIcon.png" alt />
              <div class="text-16px text-white ml-4px">工作包附件</div>
            </div> -->
            <a
              target="_blank"
              :href="ele.urlAddress"
              class="w-[calc(100%-40px)] truncate text-left !inline-block text-14px !leading-20px text-white h-20px align-middle"
              >{{ ele.fileOriginName }}</a
            >
            <i class="el-icon-view ml-10px !leading-20px h-20px text-white" @click="changeToPreview(ele.urlAddress)"></i>
          </div>
        </template>
        <div class="w-full flex justify-start items-center leading-30px h-30px mt-16px mb-10px">
          <img src="../../../assets/images/titleIcon.png" alt />
          <div class="text-16px text-white ml-4px">物资信息</div>
        </div>
        <el-table
          :data="item.materialList"
          :height="item.materialList.length > 4 ? 200 : item.materialList.length * 50 + 30"
          class="w-full text-12px"
        >
          <el-table-column
            width="70"
            prop="materialCode"
            show-overflow-tooltip
            label="物资编码"
            align="center"
          ></el-table-column>
          <el-table-column
            width="70"
            prop="materialName"
            show-overflow-tooltip
            label="物资名称"
            align="center"
          ></el-table-column>
          <el-table-column
            width="70"
            align="center"
            prop="demandNum"
            show-overflow-tooltip
            label="需求数量"
          ></el-table-column>
          <el-table-column
            width="90"
            align="center"
            prop="arrivalTime"
            show-overflow-tooltip
            label="到位时间"
          ></el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
// import cardTitle from '@/components/cockpit/CardTitle'
import axios from 'axios'

export default {
  // components: {
  //   cardTitle,
  // },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      // 任务详情数据列表
      currentRelationData: [],
      nsdBaseIp: '',
      activeName: 0,
    }
  },
  methods: {
    // 跳转工作包页面
    changeToPreview(url) {
      window.open(url)
    },
  },
  watch: {
    transferProps: {
      async handler(val) {
        this.nsdBaseIp =
          Wiz.globalSettings.globalConfig?.modelSetting?.nsdLoadBaseIp || 'http://192.168.1.5:8157'
        this.currentRelationData = [...val.taskRow]
        if (!this.currentRelationData[0]) return
        if (this.currentRelationData[0] && this.currentRelationData[0].materialList.length) {
          this.currentRelationData[0].materialList[0].arrivalTime = '2020-04-01'
        }
        for (let i = 0; i < this.currentRelationData.length; i++) {
          if (this.currentRelationData[i].nsdPackage) {
            await this.getFilePreviewAddress(
              this.currentRelationData[i].nsdPackage.extFileInfoList,
              this.currentRelationData[i].nsdPackage.taskId
            )
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @description 获取文件预览地址
     * @param {list:Array} 文件列表
     */
    async getFilePreviewAddress(list, taskId) {
      axios.defaults.headers.common.Authorization = `Bearer ${Wiz.AuthHooks.GetToken()}`
      for (let i = 0; i < list.length; i++) {
        const res = await axios.get(
          `${this.nsdBaseIp}/api/pack/getFilePreviewUrl?taskId=${taskId}&fileId=${
            list[i].id
          }&authToken=${Wiz.AuthHooks.GetToken()}`
        )
        if (res.data && res.data.code === 200) {
          this.$set(list[i], 'urlAddress', res.data.data)
        }
      }
    },
  },
  async created() {
    this.nsdBaseIp =
      Wiz.globalSettings.globalConfig?.modelSetting?.nsdLoadBaseIp || 'http://192.168.1.5:8157'
  },
  beforeDestroy() {},
}
</script>

<style lang="scss">
.btn-example {
  background: var(--cockpitTableHeaderTrBg) !important;
  background-blend-mode: var(--cockpitTableHeaderTrBgBlendMode);
  color: white !important;
}
.component-container {
  background-image: var(--containerBgImg);
  background-size: 100% 100%;
  padding: var(--containerPadding);
}
.el-collapse .el-collapse-item__header {
  /* background-color: transparent !important; */
  background-color: #004655 !important;
  border-width: 0;
  height: 30px;
  color: rgba($color: #fff, $alpha: 0.6);
  .el-collapse-item__arrow {
    margin-left: -60px;
  }
  span {
    margin-left: 20px;
  }
}
.el-collapse .el-collapse-item__header.is-active {
  background-color: #0f6b73 !important;
  color: white;
}
.el-collapse .el-collapse-item__wrap {
  background-color: transparent !important;
}
.el-collapse .el-collapse-item__content {
  background-color: transparent !important;
  padding: 14px;
  padding-top: 8px;
}
</style>
